import { DOMAIN_CDN, PROXY_IMAGE, WEB_HOST } from 'sysconfig';
import { convertImage } from './ImageUtils';

// đổi link storage (storage.googleapis.com...) về GCS_HOST, link khác giữ nguyên
export const changeDomainStorage = (url) => convertImage({ url });

// legacy: trước đây build link qua `${DOMAIN_IMAGE_CACHE_LOADER}/_next/image?url=...` (service
// cache-image cũ của VN); giờ convert thẳng về GCS_HOST kèm params width/height/quality
export const getLinkImageCache = ({ src, width = null, height = null, quality = 100 }) =>
  convertImage({ url: src, width, height, quality });

export const getLinkCacheFromGG = ({ src, width = null, height = null, quality = 100 }) =>
  convertImage({ url: src, width, height, quality });

// 2 hàm dưới xử lý ảnh static theo WEB_HOST/DOMAIN_CDN, không phải link storage
export const getLinkImageStaticWebHost = (url) =>
  url?.startsWith(WEB_HOST) || url?.startsWith(PROXY_IMAGE) ? url : WEB_HOST + url;
export const getLinkImageStatic = (url) =>
  (url?.startsWith(WEB_HOST) || url?.startsWith(DOMAIN_CDN) || url?.startsWith(PROXY_IMAGE)
    ? url
    : WEB_HOST + url
  ).replace(`${WEB_HOST}`, `${DOMAIN_CDN || WEB_HOST}`);

export const getLinkImageStaticCache = ({
  url,
  width = null,
  height = null,
  quality = 100,
  isCache = true,
}) => {
  if (!isCache) {
    return convertImage({ url: getLinkImageStatic(url) });
  }
  return convertImage({ url: getLinkImageStatic(url), width, height, quality });
};
